<form
  [formGroup]="loginForm"
  [@demoAnimation]="{
    value: '',
    params: {
      from: (lastFormTracker | async) === 'ACCESSCODE' ? '40%' : '-40%'
    }
  }"
>
  <mat-form-field class="w-full" appearance="fill">
    <mat-label>{{ "page.login.form.login.usernameField.label" | translate }}</mat-label>
    <input
      matInput
      noWhiteSpace="WIPE"
      id="txtLoginUserName"
      type="text"
      name="username"
      [maxlength]="10"
      placeholder="{{ 'page.login.form.login.usernameField.label' | translate }}"
      formControlName="userID"
    />
    <mat-error *ngIf="loginForm.get('userID')?.hasError('required')">{{ "page.login.form.login.usernameField.requiredMessage" | translate }}</mat-error>
    <mat-error *ngIf="loginForm.get('userID')?.hasError('maxLength') || loginForm.get('userID')?.hasError('invalidLength')">
      {{ "page.login.form.login.usernameField.invalidLengthMessage" | translate }}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="w-full" appearance="fill">
    <mat-label>{{ "page.login.form.login.passwordField.label" | translate }}</mat-label>
    <input
      matInput
      id="txtLoginPwd"
      [type]="(hidePassword) ? 'password' : 'text'"
      name="password"
      [maxLength]="20"
      placeholder="{{ 'page.login.form.login.passwordField.label' | translate }}"
      formControlName="password"
    />
    <i class="fa-regular showPasswordIcon" [ngClass]="toggleIcon" (click)="togglePasswordDisplay()"></i>
    <mat-error *ngIf="loginForm.get('password')?.hasError('required')">{{ "page.login.form.login.passwordField.requiredMessage" | translate }}</mat-error>
  </mat-form-field>

  <div class="forgotButton">
    <section class="example-section">
      <kendo-label
        class="KeepMeLoggedin"
        text="{{ 'page.login.form.login.rememberLoginOption.label' | translate }}"
      >
        <kendo-switch
          id="swtRememberMe"
          size="small"
          [offLabel]="('page.login.form.login.rememberLoginOption.off' | translate)"
          [onLabel]="('page.login.form.login.rememberLoginOption.on' | translate)"
          formControlName="rememberMe"
          (valueChange)="openTermsAndConditionsDialog($event)"
        ></kendo-switch>
      </kendo-label>
    </section>
    <button
      class="mobileHide"
      type="button"
      name="forgot-password-button"
      id="btnFotgotPassword"
      (click)="showPasswordRecoveryForm()"
    >
      {{ "page.login.form.login.forgotPasswordButton" | translate }}
    </button>
  </div>
  <div class="BtnWrapper">
    <button
      type="submit"
      kendoButton
      id="btnLogin"
      color="primary"
      name="login-button"
      id="btnSubmit"
      [disabled]="!loginForm.valid"
      (click)="login()"
    >
      {{ "page.login.form.login.loginButton" | translate }}
    </button>
  </div>
  <div class="MobileForgotButton">
    <button
      id="lnkForgotPwd"
      class="mobileShow"
      name="forgot-password-button"
      (click)="showPasswordRecoveryForm()"
    >
      {{ "page.login.form.login.forgotPasswordButton" | translate }}
    </button>
  </div>
</form>
